"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnChainTransferDirection = void 0;
/**
 * Direction of an on-chain transfer (from ARGOS).
 * @TranslateToPython
 */
var OnChainTransferDirection;
(function (OnChainTransferDirection) {
    OnChainTransferDirection["In"] = "in";
    OnChainTransferDirection["Out"] = "out";
})(OnChainTransferDirection || (exports.OnChainTransferDirection = OnChainTransferDirection = {}));
